// Navbar.js

import React from "react";
import { AppBar, Toolbar, Typography, IconButton } from "@mui/material";
import { Link } from "react-router-dom";
import { ReactComponent as SidebarIcon } from "../../assets/icons/sidebaricon.svg";

const Navbar = ({ onSidebarToggle, classes, isAuthenticated }) => {
  return isAuthenticated ? (
    <AppBar position="static" className={classes.appBar}>
      <Toolbar>
        <IconButton
          edge="start"
          color="inherit"
          aria-label="menu"
          sx={{
            ":hover": {
              background: "none",
            },
          }}
          onClick={onSidebarToggle}>
          <SidebarIcon />
        </IconButton>
      </Toolbar>
    </AppBar>
  ) : (
    <AppBar position="static">
      <Toolbar>
        {/* Company Logo */}
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          <Link to="/" style={{ color: "inherit", textDecoration: "none" }}>
            Webspero
          </Link>
        </Typography>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
